import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SatelliteAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"satellite_alt"}/>
}
